<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="rounded-t mb-0 px-2 py-1 border-0">
          <h3 class="font-semibold text-base text-blueGray-700">
            프로젝트별 실시간 크롤링 현황
          </h3>
        </div>
      </div>
    </div>
    <div class="block w-full overflow-x-auto">
      <!-- Projects table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
          <tr>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              프로젝트명
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              수집기간
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              언론
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              블로그
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              지식인
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              카페
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              커뮤니티
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              유튜브
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(project, index) in paginatedData"
            :key="index"
            @click="selectProject(project)"
            :class="[
              'border-b border-blueGray-200 transition-colors cursor-pointer',
              selectedProjectId === project.name
                ? 'bg-violet-100 hover:bg-violet-200'
                : 'hover:bg-blueGray-50'
            ]"
          >
            <th
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-left font-bold text-blueGray-700"
            >
              {{ project.name }}
            </th>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="text-blueGray-600">{{ project.collectionPeriod }}</div>
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="font-semibold text-blueGray-600"><animated-number :value="project.press.total" />건</div>
              <div class="text-xs mt-1" :class="project.press.isIncrease ? 'text-emerald-500' : 'text-blueGray-400'">
                <i v-if="project.press.isIncrease && project.press.daily > 0" class="mdi mdi-arrow-up"></i>
                <animated-number v-if="project.press.daily > 0" :value="project.press.daily" />
                <span v-else>-</span>
              </div>
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="font-semibold text-blueGray-600"><animated-number :value="project.blog.total" />건</div>
              <div class="text-xs mt-1" :class="project.blog.isIncrease ? 'text-emerald-500' : 'text-blueGray-400'">
                <i v-if="project.blog.isIncrease && project.blog.daily > 0" class="mdi mdi-arrow-up"></i>
                <animated-number v-if="project.blog.daily > 0" :value="project.blog.daily" />
                <span v-else>-</span>
              </div>
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="font-semibold text-blueGray-600"><animated-number :value="project.kin.total" />건</div>
              <div class="text-xs mt-1" :class="project.kin.isIncrease ? 'text-emerald-500' : 'text-blueGray-400'">
                <i v-if="project.kin.isIncrease && project.kin.daily > 0" class="mdi mdi-arrow-up"></i>
                <animated-number v-if="project.kin.daily > 0" :value="project.kin.daily" />
                <span v-else>-</span>
              </div>
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="font-semibold text-blueGray-600"><animated-number :value="project.cafe.total" />건</div>
              <div class="text-xs mt-1" :class="project.cafe.isIncrease ? 'text-emerald-500' : 'text-blueGray-400'">
                <i v-if="project.cafe.isIncrease && project.cafe.daily > 0" class="mdi mdi-arrow-up"></i>
                <animated-number v-if="project.cafe.daily > 0" :value="project.cafe.daily" />
                <span v-else>-</span>
              </div>
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="font-semibold text-blueGray-600"><animated-number :value="project.community.total" />건</div>
              <div class="text-xs mt-1" :class="project.community.isIncrease ? 'text-emerald-500' : 'text-blueGray-400'">
                <i v-if="project.community.isIncrease && project.community.daily > 0" class="mdi mdi-arrow-up"></i>
                <animated-number v-if="project.community.daily > 0" :value="project.community.daily" />
                <span v-else>-</span>
              </div>
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="font-semibold text-blueGray-600"><animated-number :value="project.youtube.total" />건</div>
              <div class="text-xs mt-1" :class="project.youtube.isIncrease ? 'text-emerald-500' : 'text-blueGray-400'">
                <i v-if="project.youtube.isIncrease && project.youtube.daily > 0" class="mdi mdi-arrow-up"></i>
                <animated-number v-if="project.youtube.daily > 0" :value="project.youtube.daily" />
                <span v-else>-</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div v-if="totalPages > 1" class="px-6 py-4 border-t border-blueGray-100">
      <div class="flex items-center justify-between">
        <div class="text-sm text-blueGray-500">
          {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, projects.length) }} / 총 {{ projects.length }}건
        </div>
        <div class="flex gap-2">
          <button
            @click="goToPage(1)"
            :disabled="currentPage === 1"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === 1 ? 'border-blueGray-200 text-blueGray-300 cursor-not-allowed' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            <i class="mdi mdi-chevron-double-left"></i>
          </button>
          <button
            @click="previousPage"
            :disabled="currentPage === 1"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === 1 ? 'border-blueGray-200 text-blueGray-300 cursor-not-allowed' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            <i class="mdi mdi-chevron-left"></i>
          </button>
          <button
            v-for="page in displayedPages"
            :key="page"
            @click="goToPage(page)"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === page ? 'bg-violet-500 border-violet-500 text-white' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            {{ page }}
          </button>
          <button
            @click="nextPage"
            :disabled="currentPage === totalPages"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === totalPages ? 'border-blueGray-200 text-blueGray-300 cursor-not-allowed' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            <i class="mdi mdi-chevron-right"></i>
          </button>
          <button
            @click="goToPage(totalPages)"
            :disabled="currentPage === totalPages"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === totalPages ? 'border-blueGray-200 text-blueGray-300 cursor-not-allowed' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            <i class="mdi mdi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from '@/components/common/AnimatedNumber.vue';

export default {
  components: {
    AnimatedNumber
  },
  props: {
    projectStats: {
      type: Array,
      default: () => []
    }
  },
  emits: ['project-selected'],
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 5,
      selectedProjectId: null
    };
  },
  computed: {
    projects() {
       

      const mapped = this.projectStats.map(item => {


        const pressDaily = Number(item.today_press_count) || 0;
        const blogDaily = Number(item.today_blog_count) || 0;
        const kinDaily = Number(item.today_kin_count) || 0;
        const cafeDaily = Number(item.today_cafe_count) || 0;
        const communityDaily = Number(item.today_community_count) || 0;
        const youtubeDaily = Number(item.today_youtube_count) || 0;

        // Format collection period
        const startDate = item.crawl_start_date || '';
        const endDate = item.crawl_end_date || '';
        const collectionPeriod = startDate && endDate ? `${startDate} ~ ${endDate}` : '-';



        return {
          name: item.name,
          collectionPeriod: collectionPeriod,
          press: {
            total: Number(item.press_count) || 0,
            daily: pressDaily,
            isIncrease: pressDaily > 0
          },
          blog: {
            total: Number(item.blog_count) || 0,
            daily: blogDaily,
            isIncrease: blogDaily > 0
          },
          kin: {
            total: Number(item.kin_count) || 0,
            daily: kinDaily,
            isIncrease: kinDaily > 0
          },
          cafe: {
            total: Number(item.cafe_count) || 0,
            daily: cafeDaily,
            isIncrease: cafeDaily > 0
          },
          community: {
            total: Number(item.community_count) || 0,
            daily: communityDaily,
            isIncrease: communityDaily > 0
          },
          youtube: {
            total: Number(item.youtube_count) || 0,
            daily: youtubeDaily,
            isIncrease: youtubeDaily > 0
          }
        };
      });

      console.log('Mapped projects:', mapped);
      return mapped;
    },
    totalPages() {
      return Math.ceil(this.projects.length / this.itemsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.projects.slice(start, end);
    },
    displayedPages() {
      const pages = [];
      const maxPagesToShow = 5;
      let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
      let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

      if (endPage - startPage < maxPagesToShow - 1) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    selectProject(project) {
      console.log('Project selected:', project.name);
      this.selectedProjectId = project.name;
      // Emit event with project data
      this.$emit('project-selected', this.projectStats.find(p => p.name === project.name));
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(page) {
      this.currentPage = page;
    }
  },
  mounted() {
    // Auto-select first project when data is available
    this.$nextTick(() => {
      if (this.projectStats && this.projectStats.length > 0) {
        this.selectProject({ name: this.projectStats[0].name });
      }
    });
  },
  watch: {
    projectStats: {
      handler(newVal) {
        // Auto-select first project when data loads
        if (newVal && newVal.length > 0 && !this.selectedProjectId) {
          this.$nextTick(() => {
            this.selectProject({ name: newVal[0].name });
          });
        }
      },
      immediate: true
    },
    currentPage() {
      // Auto-select first project on current page when pagination changes
      this.$nextTick(() => {
        if (this.paginatedData && this.paginatedData.length > 0) {
          this.selectProject(this.paginatedData[0]);
        }
      });
    }
  }
};
</script>
